
<style type="text/css" media="screen">
.subscription-plan-container{
	width: 320.1px;
	min-height: 255.69px;
	border-radius: 20px !important;
}

.active-card{
	border: 3px solid #1DC895 !important;
}

.inr-icon{
	margin-right: -7px;
	margin-top: -2px;
	font-size: 18px;
}

.subscription-description{
	font-family: Nunito Sans;
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	line-height: 137.5%;
	color: #78737D;
}
.card-action{
	position: absolute;
	bottom: 0px;
	width: 100%;
}
.sub_description{
	/*white-space: nowrap; */
	height: 70px; 
	overflow: hidden;
	text-overflow: ellipsis; 
}
</style>

<template>
	<div>
		<div class="pt-5 custom-slider">
			<carousel 
			:per-page="item_per_page" 
			:autoplay="autoplay"  
			:speed="speed" 
			:scrollPerPage="false"
      perPage="4"
			paginationActiveColor="#1DC895"
			loop
			>
			<slide v-for="(plan,i) in subscription_plans" :key="i"   class="elevation-0 pb-3 px-2"> 

				<v-card  max-width="360" class="subscription-plan-container elevation-2  " 
				:class="current_plan_id==plan.id?'active-card':'border-a'" >
					<v-card-text>
						<p class="sub-title-text">{{plan.name}}</p>

						<p class="sub-text-light mt-1">{{$lang.DAYS}} :<span class="sub-title-text-dark fw-700">{{plan.validity}}</span></p>
						<p class="sub-text-light mt-1">{{$lang.NO_OF_SHIPMENT_ALLOWED}} :
							<span class="sub-title-text-dark fw-700"> {{plan.shipment_count}}</span>
						</p>
						<p class="sub-text-light mt-1">{{$lang.TYPE}}: 
							<span class="sub-title-text-dark fw-700">{{plan.type}} </span>
						</p>

						<div class="subscription-description sub_description  mt-2">
							{{ plan.description | truncate(150, '...') }}
						</div>

					</v-card-text>
					<v-card-actions class="card-action border-t pb-0">
						<v-row class="w-100">
							<v-col md="8" class="text-left pl-5 py-0">
								<div class="page-title text-left">
									<span class="fs-13 fw-500">
										{{$lang.PRICE}}:
									</span>
									<span class="fw-normal">
										<v-icon class="inr-icon"  color="#303030" size="20" >mdi-currency-inr</v-icon>
										<span class="fw-bold ml-1">{{plan.price}}</span>
										<span class="fs-10 sub-text-light"> +{{plan.gst_percent}}%GST</span>
									</span>
								</div>
							</v-col>
							<v-col md="4" class="text-right py-0">
								<v-spacer>
								</v-spacer>
								<v-btn text color="primary" @click="openPaymentDialog(plan)" >
									<b>
										{{$lang.BUY.toUpperCase()}}
									</b>
								</v-btn>
							</v-col>
						</v-row>

					</v-card-actions>
				</v-card>
			</slide>
		</carousel>
	</div>

	<BuySubscriptionDialog :order_id="order_id" :transaction_token="transaction_token" :dialog="dialog2" 
	:plan="plan"
	:neft_imps_payment_instructions="neft_imps_payment_instructions" 
	:cheque_payment_instructions="cheque_payment_instructions"  
	ref="purches_shipment_dialog" />

</div>
</template>
<script type="text/javascript">
import { Carousel, Slide } from 'vue-carousel';

export default{
	components:{
		Carousel,
		Slide,
		BuySubscriptionDialog:()=>import('./BuySubscriptionDialog.vue')
	},

	props:['subscription_plans',"cheque_payment_instructions",'neft_imps_payment_instructions','current_plan_id'],
	data(){
		return{
			speed:1000,
			paginationenabled:true,
			autoplay:false,
			item_per_page:3,

			dialog:false,
			order_id:"",
			transaction_token:"",
			paymentgetway:"",
			dialog2:{
				flag:false
			},
			plan:null,
		}
	},
	filters: {
		truncate: function (text, len, suffix) {
			let new_string=text.substring(0, len) 
			if (text.length>len)
				new_string=new_string+suffix
			return new_string
		}
	},
	methods:{
		openPaymentDialog(plan){
			this.$refs.purches_shipment_dialog.step=1
			this.$refs.purches_shipment_dialog.payment_method=""
			this.plan=plan
			this.dialog2.flag=true


		}

	}
}
</script>